import React, {Component} from "react";
import {connect} from "react-redux";
import {LoaderSmall} from "../../loader";
import ModalFooter from "../modal-footer";
import {classNames} from "../../../util/util-helpers";
import MapCanvas from "../modal-global/map-dialog/map-canvas";

class LocationRadiusSearch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            SearchLatitude: this.props?.radius?.SearchLatitude ?? NaN,
            SearchLongitude: this.props?.radius?.SearchLongitude ?? NaN,
            canSubmit: false,
            SearchRadius: this.props?.radius?.SearchRadius ?? 100,
            showMap: false
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({showMap: true})
        }, 400)
    }

    submit = () => {
        this.props.handleSearchByRadius("radius", {
            SearchLongitude: this.state.SearchLongitude,
            SearchLatitude: this.state.SearchLatitude,
            SearchRadius: this.state.SearchRadius,
        })
        this.hideModal()
    }

    hideModal = () => {
        this.props.close()
    }

    addMarker = (data) => {
        this.setState({SearchLongitude: data.latlng.lng, SearchLatitude: data.latlng.lat, canSubmit: true})
    }

    render() {
        const {translate} = this.props;

        return (
            <div>
                {this.props.isLoading && (
                    <div className="p-5 text-center">
                        <LoaderSmall/>
                    </div>
                )}

                {!isNaN(this.state.SearchLatitude) && !isNaN(this.state.SearchLongitude) && (
                    <div className="pt-4 pb-2">
                        <input
                            className='w-full'
                            onChange={(e) => this.setState({
                                SearchRadius: e.target.value,
                                canSubmit: true
                            })}
                            type="range"
                            min="10"
                            max="1000"
                            value={this.state.SearchRadius}
                        />
                        <div className="row">
                            <div className="col text-tm-gray-500 text-center">
                                {this.state.SearchRadius} miles
                            </div>
                        </div>
                    </div>
                )}

                <div>
                    <div
                        className={
                            classNames(
                                !isNaN(this.state.SearchLatitude) && !isNaN(this.state.SearchLongitude)
                                    ? "w-full h-[calc(100vh-16rem)]"
                                    : "w-full h-[calc(100vh-12rem)]"
                            )
                        }
                    >
                        {!!this.state.showMap && (
                            <MapCanvas
                                onClick={this.addMarker}
                                center={[40, -100]}
                                zoom={5}
                                searchRadius={{
                                    center: [this.state.SearchLatitude, this.state.SearchLongitude],
                                    radius: this.state.SearchRadius * 1610
                                }}
                            />
                        )}
                    </div>
                </div>

                <ModalFooter
                    closeButtonLabel={translate("btn.cancel")}
                    onClose={this.hideModal}
                    buttonDisabled={!this.state.canSubmit}
                    buttonLabel={translate("btn.save")}
                    onButtonClick={this.state.canSubmit && this.submit}
                />
            </div>
        )
            ;
    }
}

export default connect(state => state)(LocationRadiusSearch);
